import httpService from './http.service';

const paymentGatewaysService = {
  getAllPaymentGateways,
  getPaymentGatewayById,
  createPaymentGateway,
  updatePaymentGateway,
  removePaymentGateway,
  getAllPaymentMethods,
  getPaymentMethodById,
  createPaymentMethod,
  updatePaymentMethod,
  removePaymentMethod,
  getAllPaymentMethodGateways,
  getPaymentMethodGatewayById,
  createPaymentMethodGateway,
  updatePaymentMethodGateway,
  removePaymentMethodGateway,

  getAllChargeStatus,
  getChargeStatusById,
  createChargeStatus,
  updateChargeStatus,
  removeChargeStatus,

  getAllChargeStatusGateways,
  getChargeStatusGatewayById,
  createChargeStatusGateway,
  updateChargeStatusGateway,
  removeChargeStatusGateway,
};

// Payment Gateways

function getAllPaymentGateways() {
  return httpService.get('/payment-gateway');
}

function getPaymentGatewayById(id) {
  return httpService.get(`/payment-gateway/${id}`);
}

function createPaymentGateway(gateway) {
  return httpService.post('/payment-gateway', gateway);
}

function updatePaymentGateway(id, gateway) {
  return httpService.put(`/payment-gateway/${id}`, gateway);
}

function removePaymentGateway(id) {
  return httpService.delete(`/payment-gateway/${id}`);
}

// Payment Methods

function getAllPaymentMethods() {
  return httpService.get('/payment-method');
}

function getPaymentMethodById(id) {
  return httpService.get(`/payment-method/${id}`);
}

function createPaymentMethod(paymentMethod) {
  return httpService.post('/payment-method', paymentMethod);
}

function updatePaymentMethod(id, paymentMethod) {
  return httpService.put(`/payment-method/${id}`, paymentMethod);
}

function removePaymentMethod(id) {
  return httpService.delete(`/payment-method/${id}`);
}

// Payment Method Gateway

function getAllPaymentMethodGateways() {
  return httpService.get('/payment-method-payment-gateway');
}

function getPaymentMethodGatewayById(id) {
  return httpService.get(`/payment-method-payment-gateway/${id}`);
}

function createPaymentMethodGateway(paymentMethodGateway) {
  return httpService.post('/payment-method-payment-gateway', paymentMethodGateway);
}

function updatePaymentMethodGateway(id, paymentMethodGateway) {
  return httpService.put(`/payment-method-payment-gateway/${id}`, paymentMethodGateway);
}

function removePaymentMethodGateway(id) {
  return httpService.delete(`/payment-method-payment-gateway/${id}`);
}

// Charge Status

function getAllChargeStatus() {
  return httpService.get('/charge-status');
}

function getChargeStatusById(id) {
  return httpService.get(`/charge-status/${id}`);
}

function createChargeStatus(chargeStatus) {
  return httpService.post('/charge-status', chargeStatus);
}

function updateChargeStatus(id, chargeStatus) {
  return httpService.put(`/charge-status/${id}`, chargeStatus);
}

function removeChargeStatus(id) {
  return httpService.delete(`/charge-status/${id}`);
}

// Charge Status Gateway

function getAllChargeStatusGateways() {
  return httpService.get('/charge-status-payment-gateway');
}

function getChargeStatusGatewayById(id) {
  return httpService.get(`/charge-status-payment-gateway/${id}`);
}

function createChargeStatusGateway(chargeStatusGateway) {
  return httpService.post('/charge-status-payment-gateway', chargeStatusGateway);
}

function updateChargeStatusGateway(id, chargeStatusGateway) {
  return httpService.put(`/charge-status-payment-gateway/${id}`, chargeStatusGateway);
}

function removeChargeStatusGateway(id) {
  return httpService.delete(`/charge-status-payment-gateway/${id}`);
}

export default paymentGatewaysService;
